import { api, createErrorResponse } from './index';

export async function postSearch(
  query,
  places = ['pages', 'media'],
  limit = 10,
) {
  try {
    const response = await api.post('search', {
      term: query,
      places,
      n: `${limit}`, // FIXME: n parameter is expected to be a string see StudioNAND/ada/issues/463
    });
    return response;
  } catch (error) {
    return createErrorResponse(error);
  }
}
